import { SearchExpression } from '../../../model/search/advanced/SearchExpression';
import { Field } from '../../../model/search/advanced/Field';
import { AdvancedSearch } from '../../../model/search/advanced/AdvancedSearch';

import { Factory } from '../../../services/Factory';


export interface IExpressionBuilderScope extends angular.IScope {
  fields: Field[];
  searchExpression: SearchExpression;
  advancedSearch: AdvancedSearch;
  project;
  collection: any;
  savedSearches: AdvancedSearch[];
  search: Function;
  save: Function;
  saveAs: Function;
  clear: Function;
  saveEnabled: () => Boolean;
  saveAsEnabled: () => Boolean;
}

export interface IExpressionBuilderAttributes extends angular.IAttributes {
}

export class ExpressionBuilder implements angular.IDirective {
  public restrict = 'E';
  public templateUrl: string;
  public scope = {
    searchExpression: '=ngModel',
    fields: "=availableFields",
    advancedSearch: "=",
    project: "=",
    collection: "=",
    savedSearches: "="
  };
  public require = ['ngModel'];
  public link: (scope: IExpressionBuilderScope, element: angular.IAugmentedJQuery, attrs: IExpressionBuilderAttributes) => void;


  constructor(searchService: app.services.search.advanced.SearchService, $rootScope: IRootScope, modal, notificationService) {
    this.templateUrl = "partials/search/advanced/expression_builder.html";
    this.link = (scope: IExpressionBuilderScope, element: angular.IAugmentedJQuery, attrs: IExpressionBuilderAttributes) => {
      scope.search = (project, collection, expression: SearchExpression, page: number, limit: number) => {
        $rootScope.$broadcast("Search.SearchExecuted", {advanced: true, expression: expression});
      };

      scope.$watch("advancedSearch", (advancedSearch: AdvancedSearch) => {
        advancedSearch.dirty = true;
      }, true);

      scope.saveEnabled = () => {
        return (scope.advancedSearch.id && scope.advancedSearch.dirty) || (!scope.advancedSearch.id && (scope.advancedSearch.expression.fields.length > 0 || scope.advancedSearch.expression.searchExpressions.length > 0));
      };

      scope.saveAsEnabled = () => {
        return scope.advancedSearch.id && scope.advancedSearch.dirty;
      };

      scope.save = () => {
        if (scope.saveEnabled()) {
          if (!scope.advancedSearch.id) {
            modal.open({
              backdrop: true,
              keyboard: true,
              backdropClick: true,
              size: "modal-sm",
              templateUrl: "partials/search/advanced/save_search.html",
              controller: "SaveSearchModalController",
              scope: scope,
              resolve: {
                search: () => scope.advancedSearch,
                project: () => scope.project
              }
            });
          } else {
            searchService.Save(scope.project, scope.advancedSearch).then(() => {
                $rootScope.$broadcast("AdvancedSearch.Saved");
                modal.close();
              }, () => {
                notificationService.addError({
                  title: "Error Saving Search",
                  timeout: 5000
                });
              }
            );
          }
        }
      };

      scope.saveAs = () => {
        if (scope.saveAsEnabled()) {
          modal.open({
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            size: "modal-sm",
            templateUrl: "partials/search/advanced/save_search.html",
            controller: "SaveSearchModalController",
            scope: scope,
            resolve: {
              search: () => scope.advancedSearch,
              project: () => scope.project
            }
          });
        }
      };

      scope.clear = () => {
        scope.advancedSearch = new AdvancedSearch(scope.advancedSearch.context);
      };

      scope.$on("ProjectService.CurrentProjectChanged", () => scope.clear());

      scope.$on("AdvancedSearch.Edit", (e, search) => {
        scope.advancedSearch = AdvancedSearch.From(search);
      });

      scope.$on("AdvancedSearch.Deleted", (e, id) => {
        if (scope.advancedSearch.id === id) {
          scope.clear();
        }
      });
    };
  }
}

frontendApp.directive("iioAdvancedSearchExpressionBuilder", ["AdvancedSearchService", "$rootScope", "$uibModal", "NotificationService", Factory.Create(ExpressionBuilder)]);
